// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  AlertIcon,
  Box,
  CheckboxField,
  Flex,
  Image,
  Link,
  Typography,
} from '@iheartjane/reefer';
import type { Row } from '@tanstack/react-table';
import type { MouseEventHandler } from 'react';

import { useImage } from '@jane/shared/components';

import type { ProductTableFeatures } from './productTableFeatures';

const StyledTypography = styled(Typography)({
  '@supports (-webkit-line-clamp: 2)': {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const StyledFlex = styled(Flex)({
  maxWidth: 400,
  wordWrap: 'break-word',
  whiteSpace: 'normal',
});

export const UnpublishedProductCell = ({
  handleClick,
  invalid,
  isBulkEditTable = false,
  row,
}: {
  handleClick: MouseEventHandler<HTMLInputElement>;
  invalid?: boolean;
  isBulkEditTable?: boolean;
  row: Row<ProductTableFeatures, any>;
}) => {
  const { imageSrc } = useImage(row.original.pos_data);

  const url = `${row.original.unmapped_product_id}`;

  return (
    <Link
      to={row.original.status === 'publishing' ? undefined : url}
      onClick={(event) => {
        event.stopPropagation();
      }}
      variant="minimal"
    >
      <Flex alignItems="center" ml={64} maxWidth={400}>
        {isBulkEditTable ? (
          <Box pr={24}>
            <CheckboxField
              label={`${row.original.id}-checkbox`}
              name={`${row.original.id}-checkbox`}
              labelHidden
              checked={row.getIsSelected()}
              onClick={handleClick}
            />
          </Box>
        ) : null}
        <Box width={24} mr={16}>
          {invalid ? <AlertIcon color="error" /> : null}
        </Box>
        <StyledFlex alignItems="center">
          <Image
            height="48px"
            width="48px"
            border
            borderRadius="12px"
            src={imageSrc}
            altText={row.original.alias}
          />
          <StyledTypography
            variant="body-semibold"
            mx={24}
            {...{ title: row.original.name }}
          >
            {row.original.alias}
          </StyledTypography>
        </StyledFlex>
      </Flex>
    </Link>
  );
};
